import React, { useState, useEffect } from 'react';
import { FaAngleDown, FaAngleUp, FaPlus } from "react-icons/fa";
import KeyValuePair from './KeyValuePair';
import styles from './reviewSharedData.module.scss';
import styles2 from '../sharedData/viewSharedData.module.scss';
import { useSelector, useDispatch } from "react-redux";
import sharedDataApi from "../../api/sharedDataApi";


const RenderData = ({ data, label, level = 0 }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [tempModelNumber, setTempModelNumber] = useState("");
  const actionItem = useSelector(
      (state) => state.reviewSharedData.actionItemData
    );

  // fetch temp model number from SdpAutoDeleteSchedule
  useEffect(() => {
    if (level === 0 && actionItem?.ModelNumber) {
      const fetchTempModel = async () => {
        try {
          const res = await sharedDataApi.listSdpAutoDeleteSchedules({
            filter: {
              actual_model_number: { eq: actionItem.ModelNumber }
            }
          });
          const items = res?.items || [];
          if (items.length > 0) {
            setTempModelNumber(items[0].temp_model_number);
          }
        } catch (err) {
          console.error("Error fetching temp model number:", err);
        }
      };
      fetchTempModel();
    }
  }, [level, actionItem?.ModelNumber]);

  // toggle function
  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  // data not an object
  if (typeof data !== 'object' || data === null) {
    return null;
  }

  const tableStyle1 = {
    tableLayout: 'fixed',
    width: '92vw',
    boxSizing: 'border-box',
    margin: '0vw'
  };

  const formatValue = (key, value) => {
    if (key !== "Category") return value;

    try {
      return Object.entries(JSON.parse(value))
        .map(([k, v]) => `${k}: ${v}`)
        .join(", ");
    } catch {
      return value;
    }
  };

  // Render nested object data with collapsible header
  return (
    <div className={styles.nestedObject}>
      <h3 onClick={toggleCollapse} >
        {label} {isCollapsed ? <FaAngleUp /> : <FaAngleDown />}
      </h3>
      {/* nested object, if not collapsed */}
      {!isCollapsed && (
                <div>
          {level === 0 && tempModelNumber && (
            <div style={{ margin: "10px 0 5px 0" }}>
              <b>Temp Model Name:</b>{" "}{tempModelNumber}
            </div>
          )}
          {level === 0 && actionItem?.ReasonForChange && (
                  <div style={{ margin: "10px 0 15px 0" }}>
                    <b>Comment:</b>{" "}
                    {(() => {
                      try {
                        let r = actionItem.ReasonForChange;

                        if (typeof r === "string") {
                          r = JSON.parse(r);
                        }

                        return r?.comment || "-";
                      } catch {
                        return "-";
                      }
                    })()}
                  </div>
                )}
          {/* {Object.keys(data).map(key => {
            const value = data[key];*/}
          <table style={tableStyle1} >
            <tbody>
              <tr className={styles2.header}>
                <th className={styles2.th}>Attributes</th>
                <th className={styles2.th}>Value</th>
                <th className={styles2.th}>Comments</th>
              </tr>

              {Object.keys(data)
              .filter((key) => key !== "AMSAck")
              .map((key, index) => {
                const value = data[key];
                let backgroundColor = "white"
                if (index % 2 !== 0) {
                  backgroundColor = '#f5f5f5';
                }
                const styleObj = {
                  backgroundColor
                }
                // Check value= is an object (not an array or null) to render recursively
                if (typeof value === 'object' && value !== null && !Array.isArray(value)) {

                  // Recursively render nested objects using the 'RenderData' component
                  return <RenderData key={key} data={value} label={key.trim()} level={level + 1}/>;

                }
                return (
                  // Key-value pairs with hover effect
                  //<KeyValuePair key={key} label={key} value={value} />
                  //{/*<td className={styles.td}>{key}</td>
                  //  <td className={styles.td}>{value}</td>*/}
                  <>
                    <tr key={key} style={styleObj}>
                      <KeyValuePair key={key} label={key} value={formatValue(key, value)} />
                    </tr>
                  </>

                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default RenderData;
